import { FC } from "react";
import '../styles/Bio.css'
import { FaWhatsapp } from "react-icons/fa";
import { FaMapMarkerAlt } from "react-icons/fa";

interface BioProps {
}

const Bio: FC<BioProps> = () => {
    const ASSET_ROOT = "/assets/bio/";
    const LOGO_PATH = `${ASSET_ROOT}logo wooblazz lingkaran.png`;
    const WOOBLAZZ_PATH = `${ASSET_ROOT}wooblazz.png`;
    const AI_PATH = `${ASSET_ROOT}ai-agent.png`;

    const WA_NUMBER = "6282330779799";
    const WA_TEXT = "Halo%2C%20saya%20ingin%20konsultasi%20produk%20Wooblazz%20CRM%20untuk%20bisnis%20saya";
    const WA_LINK = `https://api.whatsapp.com/send?phone=${WA_NUMBER}&text=${WA_TEXT}`;

    return (
        <div className="page-container">
            <header className="header">
                <img src={LOGO_PATH} className="logo-img" alt="Logo" />

                <h1>Wooblazz CRM</h1>
                <p>Kelola dan pantau semua aktivitas bisnis  dengan mudah dalam satu platform CRM</p>
                <div className="location">
                    <FaMapMarkerAlt size={24} color="#0085FF" />
                    Indonesia
                </div>
            </header>

            <main className="content-section">
                <h2>Solusi Terbaik Bisnis Anda</h2>

                {/* Wooblazz CRM Card */}
                <a href="https://lp.wooblazz.com/bio" target="_blank" rel="noreferrer" className="product-card wooblazz">
                    <div className="text-content">
                        <h2>Wooblazz CRM</h2>
                        <p>Kelola & pantau aktivitas bisnis dengan mudah hanya dalam satu platform CRM</p>
                        <div className="btn primary sora">Kunjungi website</div>
                    </div>
                    <div className="card-image">
                        <img src={WOOBLAZZ_PATH} alt="Tampilan Dashboard Wooblazz CRM" />
                    </div>
                </a>
                {/* Ai Agent Card */}
                <a href="https://lp.wooblazz.com/bio-aiagent" target="_blank" rel="noreferrer" className="product-card ai-agent">
                    <div className="text-content">
                        <div className="text-container">
                            <h2>AI Agent</h2>
                            <p>Solusi cerdas jawab pesan pelanggan di WhatsApp 24/7 untuk bisnismu</p>
                            <div className="btn primary sora">Kunjungi website</div>
                        </div>
                    </div>
                    <div className="card-image">
                        <img src={AI_PATH} alt="Tampilan Percakapan AI Agent" />
                    </div>
                </a>

                <h2>Tentang Kami</h2>

                <a href={WA_LINK} target="_blank" rel="noreferrer" className="link-item whatsapp-link">
                    <FaWhatsapp size={24} color="#25d366" />
                    Konsultasi Bisnis
                </a>

            </main>
        </div>
    );
}

export { Bio }